import { BackendError, Service } from '@genial/services';
import { MetaResponse } from '@genial/services/dist/models';
import { selectorFamily } from 'recoil';

import { blankMetaResponse } from '../../../utils/blankMetaResponse';
import { transformSortItem } from '../../../utils/transformSortItem';
import { advisorIdToApisSelector, partnerIdToApisSelector } from '../../master/selector';
import { normalizeFixedIncomeFilters, normalizeFixedIncomeOffers } from '../../product/normalizer';
import { DynamicCustomFiltersProps, FixedIncomeOfferEntityNormalized } from '../../product/types';
import { screenName } from '../constants';
import { DynamicProductQueryParams } from '../types';

export const fixedIncomeAvailableProductsQuery = selectorFamily<
  { data: FixedIncomeOfferEntityNormalized[]; meta: MetaResponse },
  DynamicProductQueryParams
>({
  key: 'AvailableProducts/fixedIncomeAvailableProductsQuery',
  get: ({ filtersToApply, searchTerm, page, orderBy }) => {
    return async ({ get }) => {
      try {
        const advisorSelected = get(advisorIdToApisSelector);
        const partnerSelected = get(partnerIdToApisSelector);
        const sortItems = transformSortItem(orderBy);

        const { data, meta } = await Service.FixedIncome.V1.getOffersFilter({
          ...filtersToApply,
          ...(searchTerm ? { searchTerm } : {}),
          sortItems: sortItems && [sortItems],
          page,
          limit: 10,
          screenName,
          advisorId: advisorSelected,
          partnerId: partnerSelected,
        });

        const normalizedData = normalizeFixedIncomeOffers(data);

        return { data: normalizedData, meta };
      } catch (error) {
        const backendError = error as BackendError;

        if (backendError.statusCode === 404) {
          return { data: [], meta: blankMetaResponse() };
        }

        throw error;
      }
    };
  },
});

export const fixedIncomeAvailableProductsFiltersQuery = selectorFamily<
  DynamicCustomFiltersProps,
  undefined
>({
  key: 'AvailableProducts/fixedIncomeAvailableProductsFiltersQuery',
  get: () => {
    return async () => {
      const { data } = await Service.FixedIncome.V1.getOffersCategories({
        screenName,
      });

      const normalizedData = normalizeFixedIncomeFilters(data);

      return normalizedData;
    };
  },
});
